<template>
	<div>
		<nav class="nav-tabs">
			<ul>
				<li :class="[activeTab.name === tab.name ? 'active ' + tab.name : tab.name]" v-for="tab in tabs" v-if="!tab.disabled">
					<span v-if="tab.disabled"><i :class="tab.icon"></i>{{ tab.displayName }}</span>
					<template v-if="Object.prototype.hasOwnProperty.call(tab, 'url')">
						<a :href="tab.url" target="_blank" v-if="!tab.disabled">
							<i :class="tab.icon"></i> {{ tab.displayName }} &nbsp;
						</a>
					</template>
					<template v-else>
						<a @click.prevent="setActiveTab(tab)" v-if="!tab.disabled">
							<i :class="tab.icon"></i> {{ tab.displayName }} &nbsp;
							<div class="badge badge-danger m-l-10" v-if="tab.badge">{{ tab.badge }}</div>
						</a>
					</template>
				</li>
			</ul>
		</nav>
		<slot v-for="tab in tabs" :name="tab.name" :data="activeTabData" v-if="loaded && activeTab.name === tab.name"></slot>
		<loader></loader>
	</div>
</template>

<script>
import {eventBus} from "../app";

export default {
	name: 'PageWithTabs',
	props: {
		tabs: {
			required: true
		},
		baseUrl: {
			required: true
		}
	},
	data() {
		return {
			activeTab: this.tabs[0],
			activeTabData: null,
			loaded: false
		}
	},
	mounted() {
		let url_string = window.location.href;
		let url = new URL(url_string);
		this.setActiveTab(url.searchParams.get('tab') ? this.tabs.find(element => element.name === url.searchParams.get('tab')) : this.tabs[0]);
	},
	methods: {
		setActiveTab: function (tab) {
			let vm = this;
			vm.loaded = false;
			eventBus.$emit('onLoaderStart');
			vm.activeTab = tab;
			window.history.replaceState('', '', vm.updateURLParameter(window.location.href, 'tab', tab.name));
			axios.get(vm.baseUrl, {params: {dataProvider: vm.activeTab.dataProvider}})
					.then(response => {
						vm.activeTabData = response.data;
						vm.loaded = true;
						eventBus.$emit('onLoaderFinish');
					})
					.catch(e => {
						vm.loaded = true;
						eventBus.$emit('onLoaderFinish');
					});
		},
		updateURLParameter: function (url, param, paramVal) {
			let newAdditionalURL = "";
			let tempArray = url.split("?");
			let baseURL = tempArray[0];
			let additionalURL = tempArray[1];
			let temp = "";
			if (additionalURL) {
				tempArray = additionalURL.split("&");
				for (var i = 0; i < tempArray.length; i++) {
					if (tempArray[i].split('=')[0] != param) {
						newAdditionalURL += temp + tempArray[i];
						temp = "&";
					}
				}
			}

			let rows_txt = temp + "" + param + "=" + paramVal;
			return baseURL + "?" + newAdditionalURL + rows_txt;
		},
	}
}
</script>

<style scoped>

</style>
